/************************************************************
 Cleaning Namespace
 ************************************************************/

/*
 6;Schedule Appointment
 7;Start
 12;Finalize
 71;Undo cleaning
 3;Cancel
 */

 window.cleaningNS = {
    _action: null,
    _callback: null,
    _row: null,
    // Execute Action
    executeAction: function (action, row, callback) {
        var wfId = parseInt(action.wf_id),
            actionId = parseInt(action.wf_action_id);

        this._action = action;
        this._callback = callback;
        this._row = row;

        // Cancel Requisition or Undo cleaning
        if (actionId == 3 || actionId==71)  {
            cleaningNS.openReason(cleaningNS.cancelModalHandler);
        }
        //Schedule
        else if (actionId == 6 || actionId == 7 || actionId == 12) {
            var params = {
                id: cleaningNS._action.task_id,
                wf_id: cleaningNS._action.wf_id,
                wf_status_id: cleaningNS._action.to_state_id,
                wf_action_id: cleaningNS._action.wf_action_id
            };

            Hades.loadScreen('/cleaning/edit_cleaning_record', params);
        }
        // Other actions
        else {
            cleaningNS.executeGenericAction();
        }
    },
    // Execute Generic Action
    executeGenericAction: function () {
        // Show alert for actions without undo
        workflow.executeAction(cleaningNS._action, cleaningNS._callback, cleaningNS._row);
    },
    // Open Reason
    openReason: function (callback) {
        var params = {
            task_id: cleaningNS._action.task_id,
            wf_id: cleaningNS._action.wf_id,
            wf_status_id: cleaningNS._action.to_state_id,
            wf_action_id: cleaningNS._action.wf_action_id};


        Hades.showLoading();

        $.get('/modal/generic_reason_window', params, null, "html")
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                $.fancybox({content: data, autoScale: true, autoDimensions: true});

                $('#generic-reason-modal-ct').bind('genericReasonConfirmed', callback);

                Hades.hideLoading();
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                cleaningNS._callback(false, cleaningNS._action, cleaningNS._row);
            });
    },
    // Cancel Requisition
    cancelModalHandler: function (event, data) {
        $.fancybox.close(true);

        Hades.showLoading();

        var params = {
            task_id: cleaningNS._row.task_id,
            reason_id: data.reasonId,
            other_reason: data.otherReason,
            cancel_date: data.date,
            cancel_hour: data.hour,
            wf_id: cleaningNS._row.wf_id,
            wf_status_id: cleaningNS._action.to_state_id,
            wf_action_id: cleaningNS._action.wf_action_id
        };

        $.post('/cleaning/cancel_cleaning', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    cleaningNS._callback(false, cleaningNS._action, cleaningNS._row);
                } else {
                    cleaningNS._callback(true, cleaningNS._action, cleaningNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                cleaningNS._callback(false, cleaningNS._action, cleaningNS._row);
            });
    }
};
